export function getWorkbenchFunMap() {
    let workbench = window._workbench || {};
    return workbench._funMap || {};
}

export function getLoginUserInfo() {
    let workbench = window._workbench || {};
    let user = workbench._user || {};
    return user;
}

export function isLoginUserInRootPlatform() {
    let _isRoot = false;
    let workbench = window._workbench || {};
    let user = workbench._user || {};
    if (user.platform && user.platform.toLowerCase() === 'root') {
        _isRoot = true;
    }
    return _isRoot;
}
